var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    { style: _vm.cssProps, attrs: { id: "app" } },
    [
      _c("Appbar"),
      _c(
        "v-main",
        [
          _c("Alert"),
          _vm.isLoadingResources ? _c("Loading") : _c("router-view"),
          _vm.isLoading ? _c("Loading") : _vm._e(),
        ],
        1
      ),
      _vm.showFooter ? _c("Footer") : _vm._e(),
      _vm.showPromotorTools ? _c("PromotorTools") : _vm._e(),
      _vm.showWhatsApp ? _c("WhatsAppButton") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }